import { Controller } from "@hotwired/stimulus"

// The topbar burger shows and hides the whole app rail (TMS-948).
//
// The state lives as a class on <body> rather than on the rail itself: layers
// outside the rail have to react to it too — the Academy's fixed Course Tools panel
// offsets itself from the rail's width — and they can't see a class set on an
// element they aren't inside. It is also rendered server-side from the cookie so the
// rail doesn't flash in before the JS runs.
export default class extends Controller {
  static values = {
    cookieName: { type: String, default: "app_rail_hidden" },
    hiddenClass: { type: String, default: "is-rail-hidden" },
    mobileQuery: { type: String, default: "(max-width: 767px)" }
  }

  toggle() {
    // Below this width there is no rail to show or hide — mobile_nav_controller,
    // wired to the same button, opens the phone menu instead (TMS-1106). Toggling
    // the body class here as well would leave a stale desktop preference behind.
    if (window.matchMedia(this.mobileQueryValue).matches) return

    const hidden = document.body.classList.toggle(this.hiddenClassValue)
    this.element.setAttribute("aria-expanded", String(!hidden))
    this.persist(hidden)
  }

  persist(hidden) {
    const expires = new Date()
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000)
    document.cookie = `${this.cookieNameValue}=${hidden};expires=${expires.toUTCString()};path=/`
  }
}
